export default "__VITE_ASSET__CTOHUEjN__"